export const AnswerType = {
  AI: 'AI',
  EXTRACT: 'EXTRACT',
  GROUPING: 'GROUPING',
  INTEGER: 'INTEGER',
  MULTI_CHOICE: 'MULTI_CHOICE',
  NUMERIC: 'NUMERIC',
  ORDERING: 'ORDERING',
  SINGLE_CHOICE: 'SINGLE_CHOICE',
} as const;
export type AnswerTypeEnum = keyof typeof AnswerType;

export const IdType = {
  ACCOUNT_NUMBER: 'accountNumber',
  ID_NUMBER: 'idNumber',
  MAIL: 'mail',
  PASSPORT: 'passport',
  PHONE: 'phone',
} as const;
export type IdTypeEnum = keyof typeof IdType;

/**
 * We need to use short language codes because that is what is being used to setup memo's and questions.
 * It also need to match the extract.js script .output paths.
 */
export const Language = {
  AF: 'AF',
  EN: 'EN',
  NR: 'NR',
  SE: 'SE',
  ST: 'ST',
  SS: 'SS',
  TS: 'TS',
  TN: 'TN',
  VE: 'VE',
  XH: 'XH',
  ZU: 'ZU',
 } as const;
 export type LanguageEnum = keyof typeof Language;

export const MemoMarking = {
  GUESSING_DISCOURAGED: 'GUESSING_DISCOURAGED',
  PARTIAL_ANSWERS: 'PARTIAL_ANSWERS', 
  PERFECT_ANSWERS: 'PERFECT_ANSWERS',
  SIMPLE_MARKING: 'SIMPLE_MARKING', 
} as const;
export type MemoMarkingEnum = keyof typeof MemoMarking;

export const Outcome = {
  ABSENT: 'ABSENT',
  CANCELLED: 'CANCELLED',
  FAIL: 'FAIL',
  NOT_STARTED: 'NOT_STARTED',
  PASS: 'PASS',
  RESCHEDULED: 'RESCHEDULED',
  STARTED: 'STARTED',
} as const;
export type OutcomeEnum = keyof typeof Outcome;

export const Province = {
  EASTERN_CAPE: 'EASTERN_CAPE',
  FREE_STATE: 'FREE_STATE',
  GAUTENG: 'GAUTENG',
  KWAZULU_NATAL: 'KWAZULU_NATAL',
  LIMPOPO: 'LIMPOPO',
  MPUMALANGA: 'MPUMALANGA',
  NORTHERN_CAPE: 'NORTHERN_CAPE',
  NORTH_WEST: 'NORTH_WEST',
  WESTERN_CAPE: 'WESTERN_CAPE',
} as const;
export type ProvinceEnum = keyof typeof Province;

export const Race = {
  ASIAN_OR_INDIAN: 'ASIAN_OR_INDIAN',
  BLACK_AFRICAN: 'BLACK_AFRICAN',
  COLOURED: 'COLOURED',
  WHITE: 'WHITE'
} as const;
export type RaceEnum = keyof typeof Race;

export const Status = {
  DEMO: 'DEMO',
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  UNPUBLISHED: 'UNPUBLISHED'
} as const;
export type StatusEnum = keyof typeof Status;

export const UserRole = {
  ADMIN: 'ADMIN',
  DEMO: 'DEMO',
  INSPECTOR: 'INSPECTOR',
  PARENT: 'PARENT',
  STUDENT: 'STUDENT',
  SUPERVISOR: 'SUPERVISOR',
  TESTER: 'TESTER'
} as const;
export type UserRoleEnum = keyof typeof UserRole;
